module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/RAINBOW@3x.png?1.0.17";